<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <a-form-item label="用户id">
              <a-input v-model="queryParam.userId" placeholder="用户id" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="兑奖状态">
              <j-dict-select-tag
                v-model="queryParam.status"
                placeholder="兑奖状态"
                dictCode="exchange_prizes_type"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span
              style="float: left; overflow: hidden"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button type="primary" @click="updateStatus('1')">发奖成功</a-button>
      <a-button type="primary" @click="updateStatus('3')">发奖失败</a-button>
      <a-button
        v-if="selectedRowKeys.length > 0"
        type="primary"
        icon="download"
        @click="handleExportXls('奖品兑换记录')"
        >导出</a-button
      >
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>

        <!--<span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
        </span>-->
      </a-table>
    </div>

    <market-exchange-prizes-modal
      ref="modalForm"
      @ok="modalFormOk"
    ></market-exchange-prizes-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import MarketExchangePrizesModal from './modules/MarketExchangePrizesModal';
// import { putAction,getAction } from "../../../api/manage";
import { postAction, downFiles } from '@/api/manage';
import customRender from '@/utils/customRender.js';

export default {
  name: 'MarketExchangePrizes',
  mixins: [JeecgListMixin],
  components: {
    MarketExchangePrizesModal,
  },
  data() {
    return {
      description: '奖品兑换管理页面',
      loading: false,
      // 表头
      columns: [
        {
          title: '用户id',
          align: 'center',
          dataIndex: 'userId',
          /*customRender:function (text) {
              return !text?"":(text.length>12?text.substr(0,12)+"...":text)
            }*/
        },
        {
          title: '手机号',
          align: 'center',
          dataIndex: 'phone',
          customRender: customRender,
        },
        {
          title: '兑换奖品名称',
          align: 'center',
          dataIndex: 'prizesName',
          /*customRender:function (text) {
              return !text?"":(text.length>12?text.substr(0,12)+"...":text)
            }*/
        },
        {
          title: '兑换奖品状态',
          align: 'center',
          dataIndex: 'status_dictText',
        },
        {
          title: '兑奖时间',
          align: 'center',
          dataIndex: 'createTime',
        },
        /* {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            width:147,
            scopedSlots: { customRender: 'action' }
          }*/
      ],

      url: {
        list:
          process.env.VUE_APP_CMS_MARKETING + '/market/exchange/prizes/list',
        edit:
          process.env.VUE_APP_CMS_MARKETING + '/market/exchange/prizes/edit',
        exportXlsUrl:
          process.env.VUE_APP_CMS_MARKETING +
          '/market/exchange/prizes/exportXls',
        updateStatus:
          process.env.VUE_APP_CMS_MARKETING +
          '/market/exchange/prizes/updateStatus',
      },
      dictOptions: {},
    };
  },
  computed: {},
  methods: {
    handleExportXls(fileName) {
      if (!fileName || typeof fileName != 'string') {
        fileName = '导出文件';
      }
      let param = { ...this.queryParam };
      if (this.selectedRowKeys && this.selectedRowKeys.length > 0) {
        param['selections'] = this.selectedRowKeys.join(',');
      }
      console.log('导出参数', param);
      downFiles(this.url.exportXlsUrl, param).then((data) => {
        if (!data) {
          this.$message.warning('文件下载失败');
          return;
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(
            new Blob([data], { type: 'application/vnd.ms-excel' }),
            fileName + '.xls'
          );
        } else {
          let url = window.URL.createObjectURL(
            new Blob([data], { type: 'application/vnd.ms-excel' })
          );
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', fileName + '.xls');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
        }
      });
    },
    initDictConfig() {},
    updateStatus(status) {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warn('请先选择数据');
      } else {
        var that = this;
        var ids = '';
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }
        let content =
          status === '1'
            ? '是否将选中数据设置为发奖成功'
            : '是否将选中数据设置为发奖失败';
        this.$confirm({
          title: '确认修改',
          content: content,
          onOk: function () {
            that.loading = true;
            postAction(that.url.updateStatus, { idList: ids, status: status })
              .then((res) => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.loadData();
                  that.onClearSelected();
                } else {
                  that.$message.warning(res.message);
                }
              })
              .finally(() => {
                that.loading = false;
              });
          },
        });
      }
    },
  },
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
